function setToken(token)
{
    localStorage.setItem('token', token)
}

function getToken()
{
    return localStorage.getItem('token') || ''
}

function setUser(user)
{
    localStorage.setItem('user', JSON.stringify(user))
}

function getUser(defaultValue)
{
    return JSON.parse(localStorage.getItem('user')) || defaultValue || {}
}

function setLanguage(lang)
{
    localStorage.setItem('language', lang)
}

function getLanguage(defaultValue)
{
    return localStorage.getItem('language') || defaultValue || 'en'
}

export const LocalStorageService = {
    setUser,
    getUser,
    setToken,
    getToken,
    setLanguage,
    getLanguage
}
